import React from 'react'

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

export default function ImageGallery() {
 return (
    <ImageList sx={{ width: "100%", height: 450 }} variant="woven" cols={3} gap={8}>
      {itemData.map((item) => (
        <ImageListItem key={item.img}>
          <img
            src={`${item.img}?w=161&fit=crop&auto=format`}
            srcSet={`${item.img}?w=161&fit=crop&auto=format&dpr=2 2x`}
            alt={item.title}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

const itemData = [
  {
    img: 'https://img.freepik.com/free-photo/analog-landscape-city-with-buildings_23-2149661456.jpg?w=900&t=st=1682607305~exp=1682607905~hmac=06aa4c7540c45eb5fbfd7aaacaea2baa9b91712dd4414f6726d43a5ac04e7194',
    title: 'house1',
  },
  {
    img: 'https://img.freepik.com/free-photo/3d-electric-car-building_23-2148972401.jpg?w=1060&t=st=1682607364~exp=1682607964~hmac=da71276084751cf12637a78d985f46313f34edf917b5a57777666e768fca4e55',
    title: 'house2',
  },
  {
    img: 'https://img.freepik.com/free-photo/house-isolated-field_1303-23773.jpg?size=626&ext=jpg',
    title: 'house3',
  },
  {
    img: 'https://img.freepik.com/premium-photo/close-up-modern-nice-house-being-constructed-suburb_259150-32502.jpg?size=626&ext=jpg',
    title: 'house4',
  },
  {
    img: 'https://img.freepik.com/premium-photo/modern-house-with-sky_35076-483.jpg?size=626&ext=jpg',
    title: 'house5',
  },
  {
    img: 'https://img.freepik.com/free-photo/vertical-shot-white-building-clear-sky_181624-4575.jpg?size=626&ext=jpg',
    title: 'house6',
  },
  {
    img: 'https://img.freepik.com/premium-photo/interior-home-design-living-room-with-open-kitchen-loft-house_41487-613.jpg?size=626&ext=jpg',
    title: 'house7',
  },
  {
    img: 'https://img.freepik.com/premium-photo/exterior-modern-apartment-buildings-o_100656-377.jpg?size=626&ext=jpg',
    title: 'house8',
  },
  {
    img: 'https://img.freepik.com/free-photo/loft-luxury-living-room-with-bookshelf-near-dining-table_105762-1796.jpg?size=626&ext=jpg',
    title: 'house9',
  },
  {
    img: 'https://img.freepik.com/free-photo/3d-rendering-white-wood-living-room-near-bedroom-upstair_105762-2197.jpg?size=626&ext=jpg',
    title: 'house10',
  },
  {
    img: 'https://img.freepik.com/free-photo/3d-rendering-loft-luxury-living-room-with-shelf-near-dining-table_105762-2053.jpg?size=626&ext=jpg',
    title: 'house11',
  },
  {
    img: 'https://img.freepik.com/free-photo/relax-area-resort_1150-10728.jpg?size=626&ext=jpg',
    title: 'house12',
  },
];